// This public OAuth intent returns only to the fixed consent page. It carries
// no session credential and never restores an arbitrary product/resource URL.
export function externalAuthorizationSearch(search: Record<string, unknown>): { authorize?: string } {
  const value = search['authorize']
  return typeof value === 'string' && value.length > 0 && value.length <= 4096 ? { authorize: value } : {}
}

export function externalAuthorizationFromHref(href: string): { authorize?: string } {
  try {
    const url = new URL(href, 'https://local.invalid')
    if (url.origin !== 'https://local.invalid' || !['/profile/integrations', '/account/design-integrations', '/organizations'].includes(url.pathname) || url.searchParams.getAll('authorize').length !== 1) return {}
    return externalAuthorizationSearch({ authorize: url.searchParams.get('authorize') })
  } catch { return {} }
}

export function externalAuthorizationDestination(authorize: string) {
  try {
    const resource = new URL(new URLSearchParams(authorize).get('resource') ?? '')
    if (resource.pathname === '/design-mcp/mcp') return { to: '/account/design-integrations', search: { authorize }, replace: true } as const
  } catch { /* The server preview owns protocol validity; only the fixed destination is selected here. */ }
  return { to: '/profile/$section', params: { section: 'integrations' }, search: { authorize }, replace: true } as const
}
